module.exports = __webpack_public_path__ + "img/p__四川大学.7de15740.png";